import i18next from "i18next";
import _ from "lodash";
import { useSelector } from "react-redux";

import { normalizePrice } from "../../../utils";

import ModalComponent from "../Modal";
import { Block, Buttons, Prices } from "../PriceChangedModal/style";

/**
 * Предупреждение при первом выборе в заказе способа оплаты с комиссией платёжной системы:
 * сумма к оплате выросла на комиссию. Показывается один раз на заказ (флаг — utils/paymentCommissionNotice).
 * methodId — выбранный способ оплаты, null — окно закрыто.
 */
const PaymentCommissionModalComponent = ({ methodId, onClose }) => {
  const { t, language } = i18next;
  const {
    availablePaymentMethods,
    orderData: { total_price, currency, options, purchased_options_total_price },
  } = useSelector(state => state.order);

  const method = availablePaymentMethods?.find(item => item.id === methodId);
  const commission = _.toFinite(method?.commission_value);
  if (!method || commission <= 0) return null;

  // та же сумма, что в блоке цены заказа: билеты + оформленные доп. услуги + комиссия
  const purchasedOptions = (options || []).filter(option => ["selected", "confirmed", "failed"].includes(option.status));
  const optionsAmount = purchasedOptions.length > 0 ? _.toFinite(purchased_options_total_price) : 0;
  const orderAmount = _.toFinite(total_price) + optionsAmount;
  const methodName = method.description?.[language] || method.name;

  // есть ли способ дешевле (баланс не предлагаем — у него свои условия)
  const hasCheaperMethod = (availablePaymentMethods || []).some(
    item => item.id !== methodId && item.code !== "BALANCE" && _.toFinite(item.commission_value) < commission,
  );

  return (
    <ModalComponent active onClose={onClose} flexCenter maxWidth={560} title={t("payment_commission_title")}>
      <Block>
        <p>{t("payment_commission_text", { method: methodName })}</p>

        <Prices style={{ textAlign: "left" }}>
          <div className="row">
            <span>{t("payment_commission_order_amount")}</span>
            <span style={{ whiteSpace: "nowrap" }}>
              {normalizePrice(orderAmount.toFixed(2))} {currency}
            </span>
          </div>
          <div className="row">
            <span>{t("payment_commission_fee")}</span>
            <span style={{ whiteSpace: "nowrap" }}>
              + {normalizePrice(commission.toFixed(2))} {currency}
            </span>
          </div>
          <div className="row">
            <span>{t("payment_commission_total")}</span>
            <span className="new" style={{ whiteSpace: "nowrap" }}>
              {normalizePrice((orderAmount + commission).toFixed(2))} {currency}
            </span>
          </div>
        </Prices>

        {hasCheaperMethod && <p>{t("payment_commission_hint")}</p>}

        <Buttons>
          <button type="button" className="agree" onClick={onClose}>
            {t("payment_commission_ok")}
          </button>
          {hasCheaperMethod && (
            <button type="button" className="disagree" onClick={onClose}>
              {t("payment_commission_choose_other")}
            </button>
          )}
        </Buttons>
      </Block>
    </ModalComponent>
  );
};

export default PaymentCommissionModalComponent;
